// extracted by mini-css-extract-plugin
export var printerCard = "_gf-1";
export var printerCardConfigured = "_gf-2";
export var printerCardError = "_gf-3";
export var printerCardsContainer = "_gf-0";
export var printerIcon = "_gf-8";
export var printerIconConfigured = "_gf-5";
export var printerIconContainer = "_gf-4";
export var printerIconError = "_gf-6";
export var printerIconUnconfigured = "_gf-7";
export var workstationsTableCard = "_gf-9";